<template>
    <div class="custom-page">
        <div class="content-block">
            <div class="center">
                <h4 class="content-title">{{customTitle}}</h4>
                <h6 class="content-sub-title">{{lang.pubAt}} : {{customTime}}</h6>
                <div class="content custom-content editor-gen" v-html="customContent"></div>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import gDate from '@/utils/format/gDate';
import ajax from '@/utils/ajax';

export default {
    name: 'customDetailBlock',
    components: {
        Layout,
    },
    props: {
        pageId: Number,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            customTitle: '',
            customTime: '',
            customContent: '',
        };
    },
    mounted() {
        ajax.get('/web/news/news_detail.json', {
            newsId: this.$props.pageId,
        }).then((result) => {
            this.customTitle = this.isCn ? result.data.titleChina : result.data.titleEng;
            this.customContent = this.isCn ? result.data.contentChina : result.data.contentEng;
            this.customTime = gDate.datetimeFormat(result.data.pubTime, 'YYYY-MM-DD');
        }).catch(() => {});
    },
    methods: {
    },
};
</script>
<style lang="less" scoped>
    .center {
        width: 960px;
        margin: 0 auto;
    }
    .content-title {
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        padding: 0 16px 24px;
    }
    .content-sub-title {
        text-align: center;
        font-size: 14px;
        padding: 0 16px 40px;
    }
    .content-block {
        margin-top: 10px;
        background: #fff;
        padding: 15px 0;
    }
</style>
